import { render, staticRenderFns } from "./addThemeAndSkills.vue?vue&type=template&id=18843308"
import script from "./addThemeAndSkills.vue?vue&type=script&lang=js"
export * from "./addThemeAndSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports